import { CouponsActions } from '../actions/coupons';
import {
  CONTESTS_FETCH_SUCCESS,
  COUPONS_FETCH_ERROR,
  COUPONS_FETCH_REQUEST,
} from '../actions/constants';

export type Coupon = {
  coupon_codice: string;
  coupon_info_titolo: string;
  coupon_info_link: string;
};

type CouponsState = {
  data: Coupon[];
  error: boolean;
  fetching: boolean;
};

const COUPONS_INITIAL_STATE: CouponsState = {
  data: [],
  error: false,
  fetching: false,
};

export const coupons = (
  state = COUPONS_INITIAL_STATE,
  action: CouponsActions
) => {
  switch (action.type) {
    case COUPONS_FETCH_ERROR:
      return {
        ...state,
        error: true,
        fetching: false,
      };
    case COUPONS_FETCH_REQUEST:
      return {
        ...state,
        error: false,
        fetching: false,
      };
    case CONTESTS_FETCH_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};
